import { useState } from 'react'

import {
  AOSRType,
  FilestoreAPI,
  SecondaryActType,
} from '@builddocs/filestore-api'
import { useDisclosure } from '@builddocs/system'
import { IconButton, Tooltip } from '@mui/material'
import fileDownload from 'js-file-download'
import { useMutation } from 'react-query'

import { DownloadActDialog } from './DownloadActDialog'

const DownloadIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_19634_63021)">
      <path
        clipRule="evenodd"
        d="M21 20.25C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21C2.25 20.5858 2.58579 20.25 3 20.25C3.41421 20.25 3.5 20.25 3.75 20.25H20.25C20.5 20.2495 20.5858 20.25 21 20.25Z"
        fill="#333333"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.96967 10.9697C7.26256 10.6768 7.73744 10.6768 8.03033 10.9697L12 14.9393L15.9697 10.9697C16.2626 10.6768 16.7374 10.6768 17.0303 10.9697C17.3232 11.2626 17.3232 11.7374 17.0303 12.0303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L6.96967 12.0303C6.67678 11.7374 6.67678 11.2626 6.96967 10.9697Z"
        fill="#333333"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11.9961 2.25C12.4103 2.25 12.7461 2.58579 12.7461 3V16C12.7461 16.4142 12.4103 16.75 11.9961 16.75C11.5819 16.75 11.2461 16.4142 11.2461 16V3C11.2461 2.58579 11.5819 2.25 11.9961 2.25Z"
        fill="#333333"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_19634_63021">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
)

const messages = {
  init: {
    message:
      'Идёт создание архива. Не закрывайте данное окно до окончания загрузки. Это может занять некоторое время. Пожалуйста, подождите.',
    type: 'info',
  },
  download: {
    type: 'info',
    message: 'Архив успешно создан и загружается на Ваш компьютер.',
  },
  done: {
    type: 'success',
    message: 'Архив успешно загружен на Ваш компьютер.',
  },
  error: {
    type: 'error',
    message: 'Произошла ошибка при скачивании архива.',
  },
} as const

export function DownloadActButton({
  act,
}: {
  act: AOSRType | SecondaryActType
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [message, setMessage] = useState('init')

  const { mutate, isLoading } = useMutation({
    mutationFn: (options: { aosrActs?: string[]; secondaryActs?: string[] }) =>
      FilestoreAPI.post(
        'project/registry-of-acts/download-acts-archive',
        options,
        {
          responseType: 'blob',
        },
      ),
    onSuccess: data => {
      const contentDisposition = data.headers['content-disposition']
      const filename = contentDisposition
        ? contentDisposition.split('filename=')[1]?.replace(/"/g, '') // Извлекаем имя файла
        : 'download.zip'

      fileDownload(data.data, filename)

      setMessage('done')
    },
    onError: () => setMessage('error'),
  })

  const handleOpen = () => {
    setMessage('init')

    if (act.actType === 'AOSR') {
      mutate({
        aosrActs: [act.id],
      })
    } else {
      mutate({
        secondaryActs: [act.id],
      })
    }

    onOpen()
  }

  return (
    <>
      <Tooltip title="Скачать акт с приложениями">
        <IconButton onClick={handleOpen}>
          <DownloadIcon />
        </IconButton>
      </Tooltip>
      <DownloadActDialog
        downloadProgress={100}
        isLoading={isLoading}
        isOpen={isOpen}
        messageState={messages[message]}
        onClose={onClose}
      />
    </>
  )
}
